
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemaps/visual-sitemap-generator",
      function () {
        return require("private-next-pages/sitemaps/visual-sitemap-generator/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemaps/visual-sitemap-generator"])
      });
    }
  